/**
 * Логирование входящих JS-запросов по WebSocket (STOMP) и исходящих ответов.
 *
 * Включено в DEV или явно:
 * - localStorage.setItem('debug_ws_js_request', 'true')
 * - VITE_WS_JS_REQUEST_DEBUG=true
 */

const STORAGE_FLAG = 'debug_ws_js_request'
const ENV_FLAG = 'VITE_WS_JS_REQUEST_DEBUG'

export function isWsJsRequestDebugEnabled(): boolean {
  if (import.meta.env.DEV) return true
  try {
    const envOn = String((import.meta.env as Record<string, unknown>)?.[ENV_FLAG] ?? '').toLowerCase() === 'true'
    const storageOn = localStorage.getItem(STORAGE_FLAG) === 'true'
    return envOn || storageOn
  } catch {
    return String((import.meta.env as Record<string, unknown>)?.[ENV_FLAG] ?? '').toLowerCase() === 'true'
  }
}

/** Снимок для консоли без мутаций исходного объекта. */
export function cloneForWsDebugLog<T>(value: T): T {
  if (value == null) return value
  try {
    return JSON.parse(JSON.stringify(value)) as T
  } catch {
    return value
  }
}

export interface WsJsRequestLogMeta {
  coreSessionId?: string
  destination?: string
  rawBodyLength?: number
}

export interface WsJsResponseLogMeta {
  requestSocketId?: string
  requestId?: string | null
  chunked?: boolean
  bodyLength?: number
  chunkCount?: number
  methodName?: string
  className?: string
}

export function logWsJsRequestInbound(request: unknown, meta: WsJsRequestLogMeta = {}): void {
  if (!isWsJsRequestDebugEnabled()) return

  const r = request as Record<string, unknown>
  const method = r?.methodName ?? r?.method_name ?? '?'
  const cls = r?.className ?? r?.class_name ?? '?'
  const requestId = r?.request_id ?? '—'

  console.groupCollapsed(
    `[WS js-request] ${String(cls)}.${String(method)} (request_id=${String(requestId)})`,
  )
  if (meta.destination) console.log('destination', meta.destination)
  if (meta.coreSessionId) console.log('coreSessionId', meta.coreSessionId)
  if (meta.rawBodyLength != null) console.log('rawBodyLength', meta.rawBodyLength)
  console.log('request (full)', cloneForWsDebugLog(request))
  console.groupEnd()
}

export function logWsJsResponseOutbound(data: unknown, meta: WsJsResponseLogMeta = {}): void {
  if (!isWsJsRequestDebugEnabled()) return

  const label = meta.methodName && meta.className
    ? `${meta.className}.${meta.methodName}`
    : 'response'

  console.groupCollapsed(
    `[WS js-response] ${label} (request_id=${String(meta.requestId ?? '—')})`,
  )
  console.log('requestSocketId', meta.requestSocketId)
  if (meta.chunked) {
    console.log('transport', 'chunked', {
      chunkCount: meta.chunkCount,
      bodyLength: meta.bodyLength,
    })
  } else if (meta.bodyLength != null) {
    console.log('bodyLength', meta.bodyLength)
  }
  console.log('response (full)', cloneForWsDebugLog(data))
  console.groupEnd()
}
